/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response after verifying the SMS code.
 * @export
 * @interface MncapVerifySmsCodeResponseDto
 */
export interface MncapVerifySmsCodeResponseDto {
    /**
     * Outcome of the verification.
     * - VALID: code is correct, redirectUrl is filled
     * - INVALID: code is wrong, remainingAttempts is filled
     * - EXPIRED: code is older than 2 min, borrower must resend
     * - MAX_ATTEMPTS_REACHED: 5 wrong tries reached, code is invalidated, borrower must resend
     * 
     * @type {string}
     * @memberof MncapVerifySmsCodeResponseDto
     */
    status: MncapVerifySmsCodeResponseDtoStatusEnum;
    /**
     * MNCAP health questionnaire URL obtained via spe7.
     * Only filled when status is VALID.
     * 
     * @type {string}
     * @memberof MncapVerifySmsCodeResponseDto
     */
    redirectUrl?: string | null;
    /**
     * Number of tries left before the code is invalidated. Filled when status is INVALID.
     * @type {number}
     * @memberof MncapVerifySmsCodeResponseDto
     */
    remainingAttempts?: number | null;
}


/**
 * @export
 */
export const MncapVerifySmsCodeResponseDtoStatusEnum = {
    Valid: 'VALID',
    Invalid: 'INVALID',
    Expired: 'EXPIRED',
    MaxAttemptsReached: 'MAX_ATTEMPTS_REACHED'
} as const;
export type MncapVerifySmsCodeResponseDtoStatusEnum = typeof MncapVerifySmsCodeResponseDtoStatusEnum[keyof typeof MncapVerifySmsCodeResponseDtoStatusEnum];


/**
 * Check if a given object implements the MncapVerifySmsCodeResponseDto interface.
 */
export function instanceOfMncapVerifySmsCodeResponseDto(value: object): value is MncapVerifySmsCodeResponseDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function MncapVerifySmsCodeResponseDtoFromJSON(json: any): MncapVerifySmsCodeResponseDto {
    return MncapVerifySmsCodeResponseDtoFromJSONTyped(json, false);
}

export function MncapVerifySmsCodeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MncapVerifySmsCodeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'redirectUrl': json['redirectUrl'] == null ? undefined : json['redirectUrl'],
        'remainingAttempts': json['remainingAttempts'] == null ? undefined : json['remainingAttempts'],
    };
}

export function MncapVerifySmsCodeResponseDtoToJSON(json: any): MncapVerifySmsCodeResponseDto {
    return MncapVerifySmsCodeResponseDtoToJSONTyped(json, false);
}

export function MncapVerifySmsCodeResponseDtoToJSONTyped(value?: MncapVerifySmsCodeResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'redirectUrl': value['redirectUrl'],
        'remainingAttempts': value['remainingAttempts'],
    };
}

